const groupPrefix = 'auth/api/public/client/email'

export const apiEmailVerification = {
	emailVerificationVerify: async (token: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/verify`, {
			method: 'POST',
			body: {
				email_verification_token: token,
			},
		})
	},

	emailVerificationResendToken: async (email: string): Promise<void> => {
		await apiCommon(`${groupPrefix}/resend-verification-email`, {
			method: 'POST',
			body: {
				email,
			},
		})
	},
}
